import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewEncapsulation, input } from '@angular/core';
import { PointerGesturesDirective } from '@workbuddy/ui/v2/directives/pointer.gestures';
import { KanbanColumn, KanbanHost, KanbanSwimlane } from '../model/kanban.model';

@Component({
  selector: 'kanban-column',
  templateUrl: 'kanban.column.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, PointerGesturesDirective]
})
export class KanbanColumnComponent {
  public readonly $host = input.required<KanbanHost>({ alias: 'host' });
  public readonly $swimlane = input.required<KanbanSwimlane>({ alias: 'swimlane' });
  public readonly $column = input.required<KanbanColumn>({ alias: 'column' });
}
